module.exports = __webpack_public_path__ + "static/media/grid-5.0feacc47.svg";